import { render, staticRenderFns } from "./EventForm1Component.vue?vue&type=template&id=fcd11f30&"
import script from "./EventForm1Component.vue?vue&type=script&lang=js&"
export * from "./EventForm1Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports